import React, {ReactNode} from 'react';
import clsx from 'clsx';

import {useTranslation} from 'react-i18next';
import {formatToTimeString, getDateProperty, toLocalDate} from '../../utils';

import styles from './Deadline.module.css';

interface DeadlineProps {
  className?: string
  textClassName?: string
  deadline: number
  separateDateTimeString: string
  startString: string | ReactNode
}

const Deadline = ({className, textClassName, deadline, separateDateTimeString, startString}: DeadlineProps) => {
  const {t} = useTranslation();

  const deadLineObj = getDateProperty(toLocalDate(deadline).getTime() / 1000);
  const hours = formatToTimeString(deadLineObj.hour);
  const minutes = formatToTimeString(deadLineObj.minute);

  return (
    <div className={clsx(styles.subText, className)}>
      {startString} &nbsp;
      <span className={textClassName}>
        {`${t('toDate', deadLineObj)} ${separateDateTimeString} ${hours}:${minutes}`}
      </span>
    </div>
  );
};

export default Deadline;